// extracted by mini-css-extract-plugin
export default {"containerHeader":"MenuSubmodules_containerHeader__1j6my","tooltip":"MenuSubmodules_tooltip__J+hYB"};